import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let LatePickUpController = {

    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/late-pick-up/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/late-pick-up/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/late-pick-up/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/late-pick-up/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/late-pick-up/delete/${id}`,
            method: 'GET'
        }, callback)
    }
}

export default LatePickUpController
